export const mutations = {
  setChatBubbles($state, chatBubbles) {
    $state.chatBubbles = chatBubbles;
  },

  setManagementUiFlags($state, uiFlags) {
    $state.uiFlags = { ...$state.uiFlags, ...uiFlags };
  },
};
